import { Container, Row, Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";

const Wholesellerintegrate = () => {
  return (
    <>
      <Container>
        <div className="screenHeight">
          <Shopintegrate
            newshop="/wholeseller-form"
            url="/wholeseller-integrate-form"
          />
        </div>
      </Container>
    </>
  );
};

export default Wholesellerintegrate;
